<div class="by-volume-order-item-list copo-container">
	<div class="card-info-block rounded padding">
		<!-- header -->
		<div class="header">
			<copo-datacenter-tool-header
				[currentView]="currentView"
				[download]="exportExcelData.bind(this)"
				[nbResults]="gridApi?.getDisplayedRowCount() ?? orderItems.length"
				[nbSelectedResults]="getCurrentSelectedGridData().length"
				[views]="views"
				(customizeView)="customizeView.emit($event)"
				(viewChange)="onViewChange($event)">
			</copo-datacenter-tool-header>
			<div class="selected-only-filter">
				<ng-container *ngIf="orderItems.length > 0">
					<copo-slide-button
						class="justify-center"
						labelAfter="filter.all"
						labelBefore="ecall-off.selected-only"
						[checked]="isAll"
						(toggleChange)="setAll($event)">
					</copo-slide-button>
					</ng-container>
			</div>
		</div>
		<!-- grid -->
		<ag-grid-angular
			class="ag-theme-balham callable-order-items"
			*ngIf="orderItems.length > 0"
			[gridOptions]="gridOptions"
			[modules]="gridModules"
			(gridReady)="onGridReady($event)"
			(rowSelected)="$event.node.data && selectOrder.emit({ data: $event.node.data, selected: $event.node.isSelected() ?? false })">
		</ag-grid-angular>
	</div>
</div>